import * as React from 'react';

import { cn } from '@/lib/utils';

export interface KbdProps extends React.HTMLAttributes<HTMLElement> {}

const Kbd = React.forwardRef<HTMLElement, KbdProps>(
    ({ className, ...props }, ref) => {
        return (
            <kbd
                ref={ref}
                className={cn(
                    'inline-flex h-7 min-w-[28px] items-center justify-center rounded-md border border-border bg-muted px-2 font-mono text-xs text-muted-foreground',
                    className,
                )}
                {...props}
            />
        );
    },
);
Kbd.displayName = 'Kbd';

export { Kbd };
